




























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Table from '@/components/common/elements/Table.vue';

@Component({
  components: { Table }
})
export default class CheckBoxTable extends Vue {
  // テーブルに表示するカラム配列
  @Prop({ default: [] })
  private columns!: Array<{ [k: string]: string }>;
  // テーブルに表示するデータ配列
  @Prop({ default: [] })
  private body!: Array<{ [k: string]: string }>;
  // 表示アイテム数
  @Prop({ default: 100 })
  private perPage?: number;
  // チェックボックス項目の表示制御
  @Prop({ default: false })
  private showSelect?: boolean;
  // テーブル内項目のchip制御
  @Prop({ default: () => ([]) })
  private chipItems?: Array<{ [k: string]: string }>;
  @Prop({ default: () => ([]) })
  private buttonItems?: Array<{ [k: string]: string }>;

  @Prop({ default: '' })
  private itemKey?: string;

  @Prop({ default: '' })
  private buttonLabel?: string;

  @Prop()
  private customFilter?: Function;

  @Prop()
  private customSort?: Function;

  /**
   * 親コンポーネントに押下した行を通知する
   * @module clickRowOpratipon
   * @param  {TableBody} - 対象行データ
   * @return {TableBody} - 押下された行データ
   */
  @Emit('clickRowOpratipon')
  public clickRowOpratipon(clickRecord: any): { [k: string]: string } {
    return clickRecord;
  }
  /**
   * 親コンポーネントにボタンを押下した行を通知する
   * @module clickButton
   * @param  {TableBody} - 対象行データ
   * @return {TableBody} - 押下された行データ
   */
  @Emit('clickButton')
  public clickButton(clickRecord: any): { [k: string]: string } {
    return clickRecord;
  }
  /**
   * 親コンポーネントにチェックボックスをチェック、アンチェックした行を通知する
   * valueにはチェックした場合true, アンチェックした場合はfalseが与えられる
   * itemは定義されているテーブル項目によって可変となる
   * @module itemSelected
   * @param {item: any, value: boolean}
   * @return {item: any, value: boolean}
   */
  @Emit('itemSelected')
  public itemSelected(value: { item: any; value: boolean }) {
    return value;
  }
  /**
   *  親コンポーネントに選択されているアイテムを配列で返します
   * @module enterSelect
   * @param Array<{[k: string]: string }>
   * @return Array<{[k: string]: string }>
   */
  @Emit('enterSelect')
  public enterSelect(list: Array<{[k: string]: string }>) {
    return list;
  }
}
